
export const isNullOrEmpty = (obj) => {

  if (typeof obj !== 'undefined' && obj !== null && obj !== '' && obj.trim() !== ''){     
    return false ;} 
  else {
    return true ;}
};
export default { isNullOrEmpty };
